import BaseHooks from './base';

export default class extends BaseHooks {}



// WEBPACK FOOTER //
// ./~/@bigcommerce/stencil-utils/src/hooks/cookie.js